import { Mesh, Object3D, type Group } from 'three'
import BaseFileLoader from './base-file-loader'
import STEPLoader from './three-loaders/step-loader'
import { ThreeItemKeys, ThreeOriginalFileTypes } from '../../../constants/three'
import { setFileLoadingStatus } from '../../../stores/file-loading'

class STEPFileLoader extends BaseFileLoader {
  // STEP loader requires OpenCascade which can't run in a Worker
  protected shouldUseWorker(): boolean {
    return false
  }

  async load(): Promise<Group> {
    return this.loadWithProgress(async () => {
      if (!this.base64File) {
        await this.loadBase64()
      }

      setFileLoadingStatus('parsing', this.file.name, 20)

      const loader = new STEPLoader()
      return new Promise((resolve, reject) => {
        loader.load(this.base64File!, (bufferGeometry: Object3D) => {
          try {
            setFileLoadingStatus('processing', this.file.name, 50)

            const children = bufferGeometry.children.map((child) => {
              const childCopy = this.scaleDownObject(child) as Mesh
              childCopy.material = this.getStandardMaterial()
              return childCopy
            })

            setFileLoadingStatus('finalizing', this.file.name, 80)

            const output = this.addMeshesToScene(children, this.file, () => ({
              [ThreeItemKeys.ORIGINAL_FILE_TYPE]: ThreeOriginalFileTypes.STEP,
            }))

            resolve(output)
          }
          catch (error) {
            reject(error)
          }
        })
      })
    })
  }
}

export default STEPFileLoader
